import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { BatchDownloadAnprFileFilters } from './list/types';

export const initialValuesBatchDownloadAnpr: BatchDownloadAnprFileFilters = {
  title: '',
  startDate: null,
  endDate: null,
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageBatchDownloadAnpr = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesBatchDownloadAnpr}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageBatchDownloadAnpr.displayName = 'Page Download ANPR Logs initializer';

export default PageBatchDownloadAnpr;
